import { Helmet } from "react-helmet";
import { useState, useEffect } from "react";
import { Heading} from "../../components";
import Navbar from "components/Navbar";

export default function CreateAccount2() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('')
    
  useEffect(() => {
    const firstName = sessionStorage.getItem('AC_firstName');
    const lastName = sessionStorage.getItem('AC_lastName');
    const email = sessionStorage.getItem('AC_email');
    setFirstName(firstName)
    setLastName(lastName)
    setEmail(email)
  }, []);

  return (
    <>
      <Helmet>
        <title>Create Your Account - Start Your Journey</title>
        <meta
          name="description"
          content="Join our community by creating an account. Stay informed with newsletters and take the first step towards a personalized experience."
        />
      </Helmet>

      <div className="w-full flex flex-col bg-gray-900_01 gap-[30px]">
        <div className="relative left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
          <Navbar />
          </div>  

        <div className="relative h-[698px] bg-gray-900_01 flex flex-col">
          <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900_01">
            <Heading className="h-12 items-center text-white-a700">Thank you for registering with us. We will review your application and send you an email. </Heading>
            <p className="h-12 text-[14px] text-white-a700">Once you receive our email, please activate your account by clicking on the activation link!</p>
            {/* 
            <Heading className="h-12 items-center text-white-a700">Once receive our email, you can activate your account by cliking the activation link. </Heading>
            */}
              <div className="w-[420px] h-[374px] p-4 flex flex-col gap-[10px] items-center text-white-a700">
                  {/* 
                  <p className="h-3 text-[12px]">Once you receive our email, please activate your account by clicking the activation link!</p>
                  <p className="h-9 text-[12px]">the <u className="text-green-500">activation link!</u> </p>
                  */}
                  <p className="h-9 text-[12px]"> Your information: </p>
                  <label className="w-full h-12 outline-none px-3 py-3" style={{ backgroundColor: '#262528', border: 'none', display: 'block' }}>
                        First Name: {`${firstName}`}
                    </label>
                    <label className="w-full h-12 outline-none px-3 py-3" style={{ backgroundColor: '#262528', border: 'none', display: 'block' }}>
                        Last Name: {`${lastName}`}
                    </label>
                    <label className="w-full h-12 outline-none px-3 py-3" style={{ backgroundColor: '#262528', border: 'none', display: 'block' }}>
                        Email: {`${email}`}
                    </label>

                  
              </div>
              <div className="w-[420px] h-[274px]"></div>    
              
          </div>
        </div>   

      </div>
    </>
  );
}
